import React, { useState, useEffect } from "react";
import FETCH from "../../../utils/fetch";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import "../LiabilityDashboard.css";

export const LiabilityInfo = (props) => {
  const [loading, setLoading] = useState(false);
  console.log("props in info", props);
  const RowData = [
    {
      id: 3,
      name: "Total Credit Lines",
      "Number Credit Card and Loans": props.total && props.total,
      "Total Amount Credit Cards and Loans":
        props.totalAmount &&
        `$${parseFloat(props.totalAmount)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      "Total Monthly Payments":
        props.totalMonthly &&
        `$${parseFloat(props.totalMonthly)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },

    {
      id: 2,
      name: "Total Loan Balances",
      "Total Auto Loans":
        props.totalAmountAll && props.totalAmountAll.auto
          ? `$${parseFloat(props.totalAmountAll.auto)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          : " $0",
      "Total Home Loans":
        props.totalAmountAll && props.totalAmountAll.realEstate
          ? `$${parseFloat(props.totalAmountAll.realEstate)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          : " $0",
      "Total Student Loans":
        props.totalAmountAll && props.totalAmountAll.student
          ? `$${parseFloat(props.totalAmountAll.student)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          : " $0",
      "Total Other Loans":
        props.totalAmountAll && props.totalAmountAll.other
          ? `$${parseFloat(props.totalAmountAll.other)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          : " $0",
    },
    {
      id: 3,
      name: "Total Credit Card Balances",
      "Total Number of Cards": props.creditCount && props.creditCount,
      "Total Balances":
        props.totalCountAndBalance &&
        `$${parseFloat(props.totalCountAndBalance)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      "Total Credit Card Utilization":
        props.totalCountAndBalance && props.totalCreditLimit
          ? `${((props.totalCountAndBalance / props.totalCreditLimit) * 100)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%`
          : "N/A",
      "Average Interest Rate":
        props.averageInterestRate && props.creditCount
          ? (props.averageInterestRate / props.creditCount).toFixed(2) + "%"
          : "N/A",
    },
    {
      id: 4,
      name: "Loan and Credit Card Details",
      "Highest Loan":
        props.highestLoan &&
        `$${parseFloat(props.highestLoan)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      "Highest Interest Rate": props.highestARP && `${props.highestARP + "%"}`,
      "Highest Monthly Payment":
        props.highestMonthly &&
        `${
          "$" +
          props.highestMonthly.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }`,
      "Average Credit Age": props.totalMonthDiff
        ? formatMonths(props.totalMonthDiff)
        : "N/A",
    },
  ];
  const moduleStateMapping = {
    Student: "student",
    Auto: "auto",
    "Real Estates": "realEstate",
    // Add more mappings if needed
  };
  function formatMonths(totalMonths) {
    // Calculate years and remaining months
    const years = Math.floor(totalMonths / 12);
    const months = (totalMonths % 12).toFixed(2);
    console.log("calling function", totalMonths);
    // Construct the formatted string
    let result = "";
    if (years > 0) {
      result += `${years} year${years > 1 ? "s" : ""}`;
    }
    if (months > 0) {
      result += ` ${months} month${months > 1 ? "s" : ""}`;
    }
    console.log("result", result.trim());
    return result.trim();
  }

  return (
    <React.Fragment>
      {RowData &&
        RowData.map((item, index) => (
          <div
            key={index}
            className="liablityInfocard"
            style={{ position: "relative" }}
          >
            <h3 className="liablitycardheading">{item.name}</h3>
            {Object.keys(item).map(
              (key, subIndex) =>
                key !== "name" &&
                key != "id" && (
                  <div key={subIndex}>
                    <div className="inforow" style={{ border: "none" }}>
                      <div
                        className="inforowData"
                        style={{
                          flexDirection: "row",
                          width: "100%",
                          alignItems: "center",
                          gap: "4%",
                          justifyContent: "left",
                        }}
                      >
                        <span className="infoTitle1"> {key}:</span>
                        <span className="infosubTitle">
                          {/* {typeof item[key] === "number" ? `$ ${item[key]}` : item[key]} */}
                          {item[key]}
                        </span>
                      </div>
                    </div>
                  </div>
                )
            )}
            <NewLoader isLoading={props.loading} />
          </div>
        ))}
    </React.Fragment>
  );
};
